/**
 * CMS Hooks
 */
import { useApiQuery } from './useApiQuery';
import { useApiMutation } from './useApiMutation';
import { cmsService } from '../services/cmsService';
import { queryTags } from '../queryTags';
import { getQueryClient } from '../queryClient';
import type {
  UpdateCmsPayload,
} from '../types/cms.types';
import type { UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';

/**
 * Get CMS data hook
 */
export function useGetCms(
  options?: Omit<UseQueryOptions<any, any, any, any[]>, 'queryKey' | 'queryFn'>
) {
  return useApiQuery({
    queryKey: [queryTags.cms],
    queryFn: () => cmsService.getCms(),
    ...options,
  });
}

/**
 * Update CMS mutation hook
 */
export function useUpdateCms(
  options?: UseMutationOptions<any, any, UpdateCmsPayload, any>
) {
  return useApiMutation<any, any, UpdateCmsPayload, any>({
    mutationFn: ((data: UpdateCmsPayload) => cmsService.updateCms(data)) as any,
    onSuccess: () => {
      getQueryClient().invalidateQueries({ queryKey: [queryTags.cms] });
    },
    ...options,
  });
}

